import { render, staticRenderFns } from "./listRoomRenovationRecordDetailsList.vue?vue&type=template&id=2590a6f1&scoped=true"
import script from "./listRoomRenovationRecordDetailsList.vue?vue&type=script&lang=js"
export * from "./listRoomRenovationRecordDetailsList.vue?vue&type=script&lang=js"
import style0 from "./listRoomRenovationRecordDetailsList.vue?vue&type=style&index=0&id=2590a6f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590a6f1",
  null
  
)

export default component.exports